import { useLocation } from 'react-router-dom';

function useQueryParams() {
  const location = useLocation();
  const searchParams: any = new URLSearchParams(location.search);
  const queryParams = {};

  // Iterujeme přes searchParams a zpracováváme query parametry
  for (const [key, value] of searchParams.entries()) {
    if (queryParams[key]) {
      // Pokud už existuje atribut se stejným názvem, převedeme ho na pole
      if (!Array.isArray(queryParams[key])) queryParams[key] = [queryParams[key]];
      queryParams[key].push(value);
    } else queryParams[key] = value;
  }

  return queryParams;
}

export default useQueryParams;
